import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import styles from "./NotFoundPage.module.scss";
import { useAppSelector } from "@redux/hooks";
import { selectProfileData } from "@redux/slices/CommonSlice";
import { getFirstAccessibleRoute } from "utils/redirectUtils";

const NotFoundPage = () => {
  const navigate = useNavigate();
  const profileData = useAppSelector(selectProfileData);

  const handleRedirect = () => {
    const firstRoute = getFirstAccessibleRoute(profileData?.enabled_navigation);
    navigate(firstRoute, { replace: true });
  };

  return (
    <div className={styles["error-page"]}>
      <div className={styles["error-page__image-container"]}>
        <img src="/images/not-found-atwork.png" alt="Not Found" />
      </div>
      <div className={styles["error-page__title"]}>Page Not Found</div>
      <div className={styles["error-page__message"]}>
        This is not quite right. Don't worry, let's get you back on track!
      </div>
      <div className={styles["error-page__button"]}>
        <Button onClick={handleRedirect} variant="outlined">
          Back to Home
        </Button>
      </div>
    </div>
  );
};

export default NotFoundPage;
